(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react-native"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define("react-native-styleman", ["react-native", "react"], factory);
	else if(typeof exports === 'object')
		exports["react-native-styleman"] = factory(require("react-native"), require("react"));
	else
		root["react-native-styleman"] = factory(root["react-native"], root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 